import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { ApiSlotsService } from '../../../../services/slots/api/api-slots.service';
import { AlertsService } from '../../../../services/alerts.service';

@Component({
  selector: 'app-slot-reward-edit-modal',
  templateUrl: './slot-reward-edit-modal.component.html',
  standalone: true,
  imports: [ModalModule, CommonModule, FormsModule]
})
export class SlotRewardEditModalComponent {

  @ViewChild('modal') modal!: ModalDirective;

  isLoading: boolean = false;
  rewardRank: number = 0;
  multiplier: number = 0;
  rarityWeight: number = 0;
  isJackpot: boolean = false;

  private callbackSaved?: () => void;

  constructor(private apiSlotsService: ApiSlotsService, private alertsService: AlertsService) {}

  show(rewardRank: number, multiplier: number, rarityWeight: number, isJackpot: boolean, callbackSaved?: () => void): void {
    this.callbackSaved = callbackSaved;
    this.rewardRank = rewardRank;
    this.multiplier = multiplier;
    this.rarityWeight = rarityWeight;
    this.isJackpot = isJackpot;
    this.isLoading = false;
    this.modal.show();
  }

  save(): void {
    this.isLoading = true;
    this.apiSlotsService.editSlotReward(this.rewardRank, this.multiplier, this.rarityWeight, this.isJackpot).then(
      () => {
        this.isLoading = false;
        this.modal.hide();
        this.alertsService.displayAlertSuccess('Slot reward updated !');
        if (this.callbackSaved) { this.callbackSaved(); }
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error updating slot reward : ' + error);
      }
    );
  }
}
